import PropTypes from 'prop-types'
import React from 'react'

class Panel extends React.Component {

  static propTypes = {
    component: PropTypes.any,
    header: PropTypes.any
  }

  render() {
    const { header, component } = this.props
    return (
      <div className="maha-page-panel">
        { header &&
          <div className="maha-page-panel-header">
            <div className="maha-page-panel-inner">
              { this._getComponent(header) }
            </div>
          </div>
        }
        <div className="maha-page-panel-body">
          <div className="maha-page-panel-inner">
            { this._getComponent(component) }
          </div>
        </div>
      </div>
    )
  }

  _getComponent(component) {
    return _.isFunction(component) || !!component.WrappedComponent? React.createElement(component) : component
  }

}

export default Panel
